import BookingInterfaces from "../../../views/Booking/Settings/Interfaces.vue";

const routes = [{ path: "interfaces", name: "booking.restaurants.settings.interfaces", component: BookingInterfaces }];

export default routes;
